import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, string } from 'prop-types'

// Below sm there is no hover to reveal the tooltip, so the stylesheet swaps the
// inline row for this full list.
function List({ lines, isCompact = false }) {
  return (
    <ul className={classnames('variation-info__list', isCompact && 'variation-info__list--compact', 'cgt-caption')}>
      {lines.map(line => <li key={line} className="variation-info__list-item">{line}</li>)}
    </ul>
  )
}

List.propTypes = {
  lines: arrayOf(string).isRequired,
  isCompact: bool,
}

export default memo(List)
